import { useEffect, useState } from "react";
import Slider from "react-slick";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
// helpers
import { getCurrentDevice } from "../../../../common/utils/helpers/currentDeviceHelpers/getCurrentDevice";

interface CatQuickSelectionProps {
  offers: Array<any>;
  selectedOffer: any;
  onSelectOffer: (offer: any) => void;
}

const slidesToShowDesktop: number = 4;
const slidesToShowMobile: number = 3;

export default function CatQuickSelection({ offers, selectedOffer, onSelectOffer }: CatQuickSelectionProps) {
  const { t } = useTranslation();
  const [initialSlide, setInitialSlide] = useState(-1); // Should be 0 or bigger in order to show Slider

  const slidesToShow = Math.min(
    getCurrentDevice() === "phone" ? slidesToShowMobile : slidesToShowDesktop,
    offers.length
  );
  const infinite = offers.length > slidesToShow;

  const settings = {
    arrows: true,
    dots: true,
    infinite: infinite,
    speed: 500,
    slidesToShow,
    slidesToScroll: slidesToShow,
    vertical: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(slidesToShowMobile, offers.length),
          slidesToScroll: Math.min(slidesToShowMobile, offers.length)
        }
      }
    ]
  };

  useEffect(() => {
    setInitialSlide(0);
  }, [offers?.length]);

  return (
    <Box>
      <Box className="cat-quick-selection-title">{t("transport.cat.quickSelectionTitle")}</Box>
      <Box ml={{ xs: 2, sm: 1 }} mr={{ xs: 2, sm: 1 }}>
        {initialSlide >= 0 && offers?.length > 0 && (
          <Slider {...settings} initialSlide={initialSlide}>
            {offers?.map((offer: any) => (
              <Box
                key={offer?.offer_code}
                className={`cat-quick-selection-item ${
                  offer?.offer_code === selectedOffer?.offer_code ? "cat-quick-selection-item__active" : ""
                }`}
                onClick={() => onSelectOffer(offer)}
                data-cy={`cat-card-${offer?.offer_code ?? offer?.name ?? ""}`}
              >
                {offer?.name}
              </Box>
            ))}
          </Slider>
        )}
      </Box>
    </Box>
  );
}
